import { render, staticRenderFns } from "./dsUserSettings.vue?vue&type=template&id=37a285f6&scoped=true"
import script from "./dsUserSettings.vue?vue&type=script&lang=js"
export * from "./dsUserSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a285f6",
  null
  
)

export default component.exports